import ArrowBackIosRounded from '@material-ui/icons/ArrowBackIosRounded';
import { useMemo, useState } from 'react';
import AppLogo from '../../components/AppLogo';
import NewsList from '../../components/NewsList';
import { useLandingVideoURL } from '../../misc/lib/video';
import './HomePage.scss';

const HomePage = () => {
  const [ videoUrl, videoUrlLoading ] = useLandingVideoURL();
  const [ isVideoReady, setIsVideoReady ] = useState(false);

  const shouldDisplayVideo = useMemo(() => {
    return !videoUrlLoading && !!videoUrl && isVideoReady;
  }, [ videoUrlLoading, videoUrl, isVideoReady ]);

  return (
    <div className="homepage-container">
      <div className="homepage-landing-video">
        <div className="homepage-video-blur-overlay"></div>
        <div style={ {
          background: 'black',
          display: !shouldDisplayVideo ? 'block' : 'none'
        } } className="homepage-video-placeholder"></div>
        <video style={ {
          display: shouldDisplayVideo ? 'block' : 'none'
        } } src={ videoUrl }
          onLoadedData={ () => setIsVideoReady(true) }
          autoPlay loop muted>
        </video>
      </div>
      <div className="homepage-welcome-title">
        <AppLogo />
      </div>
      <div className="homepage-down-arrow">
        <ArrowBackIosRounded color="inherit" />
      </div>
      <div className="homepage-hot-news">
        <h1>Legfrissebb híreink</h1>
        <NewsList />
      </div>
    </div>
  );
};

export default HomePage;
